import { useLazyQuery, useQuery } from "@apollo/client";
import { useHistory, useParams } from "react-router-dom";
import {
  GET_ALL_COLLABORATORS_CURSO_BY_ID,
  GET_ALL_COLLABORATORS_CURSO_BY_ID_SEARCH,
  GET_ALL_COURSES_BY_ID,
} from "../../../Querys/querys";
import { Rating } from "@material-ui/lab";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import SearcherTable from "../components/SearcherTable";
import { useContext, useEffect, useState } from "react";
import TableBits from "../../TableBits/TableBits";
import columns from "./components/ColumnsTable";
import UserField from "../components/UserField";
import FormatDate from "./components/FormatDate";
import MenuList from "./components/MenuList";
import Estatus from "./components/Estatus";
import { Grid } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import "../Capacitaciones/css/Capacitaciones.css";
import FormacionDesarolloContext from "../../../context/FormacionDesarollo/FormacionDesarrolloContext";
//import { string } from "yup";
import Calificacion from "./components/Calificacion";
import MenuListNoEvaluar from "./components/MenuListNoEvaluar";
//import ModalConfirmFinishCourse from "./modals/ModalConfirmFinishCourse";
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}
const Capacitaciones = (props: any) => {
  const { state, dispatch } = useContext(FormacionDesarolloContext);
  const { id } = useParams<any>();
  const realId = parseInt(id);
  const [openModal, setOpenModal] = useState(false);
  const [competencias, setCompetencias] = useState([]);
  const [temario, setTemario] = useState([]);
  const handleOpenModal = () => {
    setCompetencias(infoCurso?.competencias || []);
    setTemario(infoCurso?.temario || []);
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const history = useHistory();
  const [collaboratorList, setCollaboratorList] = useState([]);
  const [collaboratorListFilter, setCollaboratorListFilter] = useState<any[]>(
    []
  );
  const {
    data: collaborators,
    startPolling,
    stopPolling,
  } = useQuery(GET_ALL_COLLABORATORS_CURSO_BY_ID, {
    variables: {
      idCurso: realId,
    },
    fetchPolicy: "no-cache",
  });
  console.log(collaborators);
  const { data: getCursoById, loading } = useQuery(GET_ALL_COURSES_BY_ID, {
    variables: { id: id },
    fetchPolicy: "no-cache",
  });
  const [getCollaboratorsCurso, { error, data: collaboratorCurso }] =
    useLazyQuery(GET_ALL_COLLABORATORS_CURSO_BY_ID_SEARCH, {
      fetchPolicy: "no-cache",
    });

  const infoCurso = getCursoById?.GET_ALL_COURSES_BY_ID[0];
  console.log("info curso: ", infoCurso);
  const [paginationObj, setPaginationObj] = useState({
    idCurso: id,
    rowsOfPage: 10,
    pageNumber: 0,
    searchTerm: "",
    order: "desc",
    orderBy: "FechaIngreso",
  });

  useEffect(() => {
    if (collaborators && collaborators?.GET_ALL_COLLABORATORS_CURSO_BY_ID) {
      setCollaboratorList(collaborators?.GET_ALL_COLLABORATORS_CURSO_BY_ID);
      setCollaboratorListFilter(
        collaborators?.GET_ALL_COLLABORATORS_CURSO_BY_ID
      );
      console.log(collaboratorListFilter);
    }
  }, [collaborators]);

  useEffect(() => {
    if (
      collaboratorCurso &&
      collaboratorCurso.GET_ALL_COLLABORATORS_CURSO_BY_ID
    ) {
      setCollaboratorList(collaboratorCurso.GET_ALL_COLLABORATORS_CURSO_BY_ID);
      setCollaboratorListFilter(
        collaboratorCurso.GET_ALL_COLLABORATORS_CURSO_BY_ID
      );
    }
  }, [collaboratorCurso]);
  useEffect(() => {
    let currentPillFD = localStorage.getItem("currentPillFD");
    localStorage.setItem("currentPillFD", String(currentPillFD));
  });
  useEffect(() => {
    startPolling(5000);
    return () => {
      stopPolling();
    };
  }, [getCursoById, startPolling, stopPolling]);
  return (
    <>
      {loading === true ? (
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="divHeadCurso">
            <div>
              <div className="divTitleCurso">
                <span className="titleCurso">{infoCurso?.title}</span>
              </div>
              <div style={{ marginTop: "10px" }}>
                <span className="nameInstructorCurso">
                  Impartido por: {infoCurso?.bussinesNameInstructor}
                </span>
              </div>
            </div>
            <div>
              <div>
                <span className="hoursCurso">
                  Horas del curso: {infoCurso?.hours}
                </span>
              </div>
              {infoCurso?.average > 0 ? (
                <div className="starCapacitaciones">
                  <Rating
                    name="half-rating-read"
                    defaultValue={infoCurso?.average}
                    precision={0.5}
                    readOnly
                  />
                </div>
              ) : (
                <div className="starCapacitaciones">
                  <Rating
                    name="half-rating-read"
                    defaultValue={infoCurso?.average}
                    precision={0.5}
                    readOnly
                  />
                </div>
              )}
            </div>
          </div>
          <div className="divBodyCurso">
            <div className="descriptionCurse">{infoCurso?.description}</div>
          </div>

          <Box
            display="flex"
            flexDirection="column"
            p={2}
            style={{
              backgroundColor: "white",
              borderRadius: "20px",
            }}
          >
            <Box
              p={1}
              pb={8}
              display="flex"
              flexDirection="row"
              style={{ marginBottom: "-25px" }}
            >
              <Box
                display="flex"
                style={{
                  width: "100%",
                }}
                justifyContent="space-between"
              >
                <SearcherTable
                  label="Buscar por nombre / empresa / sede / área"
                  initState={collaborators}
                  setState={setCollaboratorListFilter}
                  fields={["enterprise", "campus", "area"]}
                  customSearch={(searchTerm: string) => {
                    getCollaboratorsCurso({
                      variables: {
                        idCurso: realId,
                        rowsPerPage: paginationObj.rowsOfPage,
                        pageNumber: 0,
                        searchTerm,
                        order: paginationObj.order,
                        orderBy: paginationObj.orderBy,
                      },
                    });
                    setPaginationObj({
                      ...paginationObj,
                      pageNumber: 0,
                      searchTerm,
                    });
                  }}
                />
                <div className="divDetalles">
                  <button
                    className="buttonVerDetalles"
                    onClick={handleOpenModal}
                  >
                    <VisibilityIcon className="iconoMenuViewColaborador" />
                    <span className="detallesText">Ver detalles</span>
                  </button>
                </div>
              </Box>
            </Box>
            <Box p={1} pb={8}>
              <TableBits
                columns={columns}
                rows={collaboratorListFilter}
                components={[
                  UserField,
                  null,
                  null,
                  null,
                  Estatus,
                  Calificacion,
                  FormatDate,
                  null,
                ]}
                componentOptions={
                  infoCurso?.evaluar == "true" ? MenuList : MenuListNoEvaluar
                }
                totalRecords={
                  collaboratorListFilter?.length > 0
                    ? collaboratorListFilter[0]?.totalRows
                    : 0
                }
                getData={async (paginationObj_) => {
                  setPaginationObj((val) => ({
                    ...val,
                    rowsPerPage: paginationObj_.rowsOfPage,
                    pageNumber: paginationObj_.pageNumber,
                  }));
                  getCollaboratorsCurso({
                    variables: {
                      idCurso: realId,
                      rowsPerPage: paginationObj_.rowsOfPage,
                      pageNumber: paginationObj_.pageNumber,
                      searchTerm: paginationObj.searchTerm,
                      order: paginationObj.order,
                      orderBy: paginationObj.orderBy,
                    },
                  });
                }}
                updatePaginationObj={(paginationObj_) => {
                  setPaginationObj((val) => ({
                    ...val,
                    order: paginationObj_.order,
                    orderBy: paginationObj_.orderBy,
                  }));
                  getCollaboratorsCurso({
                    variables: {
                      idCurso: realId,
                      rowsPerPage: paginationObj.rowsOfPage,
                      pageNumber: paginationObj.pageNumber,
                      searchTerm: paginationObj.searchTerm,
                      order: paginationObj_.order,
                      orderBy: paginationObj_.orderBy,
                    },
                  });
                }}
                customInitialOrderBy="Fecha"
                customInitialOrder="desc"
                customRowsPerPage={10}
                updatePageNumber={paginationObj.pageNumber}
              />
              <Grid
                direction="row"
                container
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  marginTop: "10px",
                }}
              >
                <Grid
                  xs
                  item
                  style={{
                    marginTop: "30px",
                  }}
                >
                  <Grid
                    direction="row"
                    container
                    justify="flex-start"
                    alignItems="center"
                  >
                    <div>
                      <ArrowBackIcon
                        fontSize="small"
                        style={{ color: "#fabb00" }}
                      />
                    </div>
                    <span
                      className="Return"
                      style={{ marginTop: "0px" }}
                      onClick={() => {
                        history.push(`/formacionydesarrollo`);
                      }}
                    >
                      Regresar a "Cursos"
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </>
      )}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="xs"
        fullWidth
      >
        <IconButton
          aria-label="close"
          onClick={handleCloseModal}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          style={{
            
            fontSize: "26px",
            color: "#093c5d",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            width: "100%",
          }}
        >
          Información del curso
        </DialogTitle>
        <DialogContent>
          <div>
            <h3>Competencias</h3>
            <List>
              {competencias.map((competencia: any) => (
                <ListItem key={competencia.id}>
                  <ListItemText primary={competencia.nameCompetence} />
                </ListItem>
              ))}
            </List>
          </div>
          <div>
            <h3>Temario</h3>
            <List>
              {temario.map((temarios: any) => (
                <ListItem key={temarios.id}>
                  <ListItemText primary={temarios.temario} />
                </ListItem>
              ))}
            </List>
          </div>
        </DialogContent>
        <DialogActions
          style={{
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button className="btnCancelarCurso" onClick={handleCloseModal}>
            Cerrar
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default Capacitaciones;
